import React from 'react';

import './App.css';

import '@mui/styles';

import 'react-image-gallery/styles/css/image-gallery.css';

import 'react-quill/dist/quill.snow.css';

import '@nosferatu500/react-sortable-tree/style.css';

import 'primereact/resources/themes/lara-light-blue/theme.css'; // or any other theme
import 'primereact/resources/primereact.min.css';

import { Theme } from '@mui/material/styles';
import { PrimeReactProvider } from 'primereact/api';

import OhsBackdrop from 'global-components/backdrop/OhsBackdrop';
import OhsEnv from 'global-components/env/OhsEnv';

import OhsModuleRoutes from './routes/OhsModuleRoutes';
import OhsToastContainer from './OhsToastContainer';
import GoogleTranslate from './GoogleTranslate';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

declare module '@mui/styles/defaultTheme' {
  interface DefaultTheme extends Theme {}
}
function App() {
  return (
    <div>
      <PrimeReactProvider value={{ unstyled: false }}>
        <OhsEnv />
        <OhsBackdrop />
        <OhsModuleRoutes />
        <OhsToastContainer />
        <GoogleTranslate />
      </PrimeReactProvider>
    </div>
  );
}

export default App;
